import React from 'react';

const PrettierLogo = () => (
	<svg
		width='291'
		height='72'
		viewBox='0 0 291 72'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M121.336 19.4C124.248 19.4 126.776 19.88 128.92 20.84C131.096 21.8 132.76 23.176 133.912 24.968C135.064 26.76 135.64 28.888 135.64 31.352C135.64 33.784 135.064 35.912 133.912 37.736C132.76 39.528 131.096 40.904 128.92 41.864C126.776 42.824 124.248 43.304 121.336 43.304H113.752V53H107.512V19.4H121.336ZM121.048 38.024C123.768 38.024 125.832 37.448 127.24 36.296C128.648 35.144 129.352 33.496 129.352 31.352C129.352 29.208 128.648 27.56 127.24 26.408C125.832 25.256 123.768 24.68 121.048 24.68H113.752V38.024H121.048ZM146.773 31.112C148.501 28.424 151.541 27.08 155.893 27.08V32.792C155.381 32.696 154.917 32.648 154.501 32.648C152.165 32.648 150.341 33.336 149.029 34.712C147.717 36.056 147.061 38.008 147.061 40.568V53H141.061V27.368H146.773V31.112ZM184.845 40.328C184.845 40.744 184.813 41.336 184.749 42.104H164.637C164.989 43.992 165.901 45.496 167.373 46.616C168.877 47.704 170.733 48.248 172.941 48.248C175.757 48.248 178.077 47.32 179.901 45.464L183.117 49.16C181.965 50.536 180.509 51.576 178.749 52.28C176.989 52.984 175.005 53.336 172.797 53.336C169.981 53.336 167.501 52.776 165.357 51.656C163.213 50.536 161.549 48.984 160.365 47C159.213 44.984 158.637 42.712 158.637 40.184C158.637 37.688 159.197 35.448 160.317 33.464C161.469 31.448 163.053 29.88 165.069 28.76C167.085 27.64 169.357 27.08 171.885 27.08C174.381 27.08 176.605 27.64 178.557 28.76C180.541 29.848 182.077 31.4 183.165 33.416C184.285 35.4 184.845 37.704 184.845 40.328ZM171.885 31.88C169.965 31.88 168.333 32.456 166.989 33.608C165.677 34.728 164.877 36.232 164.589 38.12H179.133C178.877 36.264 178.093 34.76 176.781 33.608C175.469 32.456 173.837 31.88 171.885 31.88ZM206.016 51.608C205.312 52.184 204.448 52.616 203.424 52.904C202.432 53.192 201.376 53.336 200.256 53.336C197.44 53.336 195.264 52.6 193.728 51.128C192.192 49.656 191.424 47.512 191.424 44.696V32.36H187.2V27.56H191.424V21.704H197.424V27.56H204.288V32.36H197.424V44.552C197.424 45.8 197.728 46.76 198.336 47.432C198.944 48.072 199.824 48.392 200.976 48.392C202.32 48.392 203.44 48.04 204.336 47.336L206.016 51.608ZM225.75 51.608C225.046 52.184 224.182 52.616 223.158 52.904C222.166 53.192 221.11 53.336 219.99 53.336C217.174 53.336 214.998 52.6 213.462 51.128C211.926 49.656 211.158 47.512 211.158 44.696V32.36H206.934V27.56H211.158V21.704H217.158V27.56H224.022V32.36H217.158V44.552C217.158 45.8 217.462 46.76 218.07 47.432C218.678 48.072 219.558 48.392 220.71 48.392C222.054 48.392 223.174 48.04 224.07 47.336L225.75 51.608ZM230.686 27.368H236.686V53H230.686V27.368ZM233.71 23.144C232.622 23.144 231.71 22.808 230.974 22.136C230.238 21.432 229.87 20.568 229.87 19.544C229.87 18.52 230.238 17.672 230.974 17C231.71 16.296 232.622 15.944 233.71 15.944C234.798 15.944 235.71 16.28 236.446 16.952C237.182 17.592 237.55 18.408 237.55 19.4C237.55 20.456 237.182 21.352 236.446 22.088C235.742 22.792 234.83 23.144 233.71 23.144ZM268.657 40.328C268.657 40.744 268.625 41.336 268.561 42.104H248.449C248.801 43.992 249.713 45.496 251.185 46.616C252.689 47.704 254.545 48.248 256.753 48.248C259.569 48.248 261.889 47.32 263.713 45.464L266.929 49.16C265.777 50.536 264.321 51.576 262.561 52.28C260.801 52.984 258.817 53.336 256.609 53.336C253.793 53.336 251.313 52.776 249.169 51.656C247.025 50.536 245.361 48.984 244.177 47C243.025 44.984 242.449 42.712 242.449 40.184C242.449 37.688 243.009 35.448 244.129 33.464C245.281 31.448 246.865 29.88 248.881 28.76C250.897 27.64 253.169 27.08 255.697 27.08C258.193 27.08 260.417 27.64 262.369 28.76C264.353 29.848 265.889 31.4 266.977 33.416C268.097 35.4 268.657 37.704 268.657 40.328ZM255.697 31.88C253.777 31.88 252.145 32.456 250.801 33.608C249.489 34.728 248.689 36.232 248.401 38.12H262.945C262.689 36.264 261.905 34.76 260.593 33.608C259.281 32.456 257.649 31.88 255.697 31.88ZM280.132 31.112C281.86 28.424 284.9 27.08 289.252 27.08V32.792C288.74 32.696 288.276 32.648 287.86 32.648C285.524 32.648 283.7 33.336 282.388 34.712C281.076 36.056 280.42 38.008 280.42 40.568V53H274.42V27.368H280.132V31.112Z'
			fill='#323232'
		/>
		<path
			d='M53.1429 13.7143H56.5715C57.5315 13.7143 58.2857 14.4686 58.2857 15.4286C58.2857 16.3886 57.5315 17.1429 56.5715 17.1429H53.1429C52.1829 17.1429 51.4286 16.3886 51.4286 15.4286C51.4286 14.4686 52.1829 13.7143 53.1429 13.7143Z'
			fill='#56B3B4'
		/>
		<path
			d='M1.71431 68.5714H18.8572C19.8172 68.5714 20.5715 69.3257 20.5715 70.2857C20.5715 71.2457 19.8172 72 18.8572 72H1.71431C0.754311 72 2.28882e-05 71.2457 2.28882e-05 70.2857C2.28882e-05 69.3257 0.754311 68.5714 1.71431 68.5714Z'
			fill='#EA5E5E'
		/>
		<path
			d='M42.8572 41.143H53.1428C54.1028 41.143 54.8571 41.8972 54.8571 42.8571C54.8571 43.8171 54.1028 44.5713 53.1428 44.5713H42.8572C41.8973 44.5713 41.143 43.8171 41.143 42.8571C41.143 41.8972 41.8973 41.143 42.8572 41.143Z'
			fill='#BF85BF'
		/>
		<path
			d='M22.2858 41.143H36.0001C36.9601 41.143 37.7144 41.8972 37.7144 42.8571C37.7144 43.8171 36.9601 44.5713 36.0001 44.5713H22.2858C21.3258 44.5713 20.5715 43.8171 20.5715 42.8571C20.5715 41.8972 21.3258 41.143 22.2858 41.143Z'
			fill='#EA5E5E'
		/>
		<path
			d='M1.71431 41.143H15.4286C16.3886 41.143 17.1429 41.8972 17.1429 42.8571C17.1429 43.8171 16.3886 44.5713 15.4286 44.5713H1.71431C0.754309 44.5713 2.28882e-05 43.8171 2.28882e-05 42.8571C2.28882e-05 41.8972 0.754309 41.143 1.71431 41.143Z'
			fill='#56B3B4'
		/>
		<path
			d='M1.71431 54.8571H18.8572C19.8172 54.8571 20.5715 55.6114 20.5715 56.5714C20.5715 57.5314 19.8172 58.2857 18.8572 58.2857H1.71431C0.754311 58.2857 2.28882e-05 57.5314 2.28882e-05 56.5714C2.28882e-05 55.6114 0.754311 54.8571 1.71431 54.8571Z'
			fill='#BF85BF'
		/>
		<path
			d='M1.71431 27.4286H18.8572C19.8172 27.4286 20.5715 28.1829 20.5715 29.1429C20.5715 30.1029 19.8172 30.8572 18.8572 30.8572H1.71431C0.754311 30.8572 2.28882e-05 30.1029 2.28882e-05 29.1429C2.28882e-05 28.1829 0.754311 27.4286 1.71431 27.4286Z'
			fill='#BF85BF'
		/>
		<path
			d='M18.8571 6.85712H53.1428C54.1028 6.85712 54.8571 7.61142 54.8571 8.57142C54.8571 9.53143 54.1028 10.2857 53.1428 10.2857H18.8571C17.8971 10.2857 17.1429 9.53143 17.1429 8.57142C17.1429 7.61142 17.8971 6.85712 18.8571 6.85712Z'
			fill='#F7BA3E'
		/>
		<path
			d='M1.7143 6.85712H12C12.96 6.85712 13.7143 7.61142 13.7143 8.57142C13.7143 9.53143 12.96 10.2857 12 10.2857H1.7143C0.754307 10.2857 2.28882e-05 9.53143 2.28882e-05 8.57142C2.28882e-05 7.61142 0.754307 6.85712 1.7143 6.85712Z'
			fill='#EA5E5E'
		/>
		<path
			d='M15.4286 61.7143H18.8572C19.8172 61.7143 20.5715 62.4686 20.5715 63.4286C20.5715 64.3886 19.8172 65.1429 18.8572 65.1429H15.4286C14.4686 65.1429 13.7143 64.3886 13.7143 63.4286C13.7143 62.4686 14.4686 61.7143 15.4286 61.7143Z'
			fill='#F7BA3E'
		/>
		<path
			d='M15.4286 20.5715H18.8572C19.8172 20.5715 20.5715 21.3258 20.5715 22.2857C20.5715 23.2457 19.8172 24 18.8572 24H15.4286C14.4686 24 13.7143 23.2457 13.7143 22.2857C13.7143 21.3258 14.4686 20.5715 15.4286 20.5715Z'
			fill='#56B3B4'
		/>
		<path
			d='M1.71431 61.7143H8.57145C9.53145 61.7143 10.2857 62.4686 10.2857 63.4286C10.2857 64.3886 9.53145 65.1429 8.57145 65.1429H1.71431C0.754309 65.1429 2.28882e-05 64.3886 2.28882e-05 63.4286C2.28882e-05 62.4686 0.754309 61.7143 1.71431 61.7143Z'
			fill='#56B3B4'
		/>
		<path
			d='M1.71431 20.5715H8.57145C9.53145 20.5715 10.2857 21.3258 10.2857 22.2857C10.2857 23.2457 9.53145 24 8.57145 24H1.71431C0.754309 24 2.28882e-05 23.2457 2.28882e-05 22.2857C2.28882e-05 21.3258 0.754309 20.5715 1.71431 20.5715Z'
			fill='#F7BA3E'
		/>
		<path
			opacity='0.5'
			d='M46.2858 61.7143H49.7142C50.6742 61.7143 51.4285 62.4686 51.4285 63.4286C51.4285 64.3886 50.6742 65.1429 49.7142 65.1429H46.2858C45.3258 65.1429 44.5715 64.3886 44.5715 63.4286C44.5715 62.4686 45.3258 61.7143 46.2858 61.7143Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M25.7143 61.7143H39.4287C40.3887 61.7143 41.143 62.4686 41.143 63.4286C41.143 64.3886 40.3887 65.1429 39.4287 65.1429H25.7143C24.7543 65.1429 24 64.3886 24 63.4286C24 62.4686 24.7543 61.7143 25.7143 61.7143Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M56.5714 61.7143H70.2858C71.2458 61.7143 72.0001 62.4686 72.0001 63.4286C72.0001 64.3886 71.2458 65.1429 70.2858 65.1429H56.5714C55.6114 65.1429 54.8571 64.3886 54.8571 63.4286C54.8571 62.4686 55.6114 61.7143 56.5714 61.7143Z'
			fill='#D0D4D8'
		/>
		<path
			d='M29.1429 34.2857H56.5714C57.5314 34.2857 58.2857 35.04 58.2857 35.9999C58.2857 36.9599 57.5314 37.7142 56.5714 37.7142H29.1429C28.1829 37.7142 27.4286 36.9599 27.4286 35.9999C27.4286 35.04 28.1829 34.2857 29.1429 34.2857Z'
			fill='#56B3B4'
		/>
		<path
			d='M12 34.2857H22.2857C23.2457 34.2857 24 35.04 24 35.9999C24 36.9599 23.2457 37.7142 22.2857 37.7142H12C11.04 37.7142 10.2857 36.9599 10.2857 35.9999C10.2857 35.04 11.04 34.2857 12 34.2857Z'
			fill='#F7BA3E'
		/>
		<path
			d='M1.71431 34.2857H5.14288C6.10288 34.2857 6.85717 35.04 6.85717 35.9999C6.85717 36.9599 6.10288 37.7142 5.14288 37.7142H1.71431C0.754309 37.7142 2.28882e-05 36.9599 2.28882e-05 35.9999C2.28882e-05 35.04 0.754309 34.2857 1.71431 34.2857Z'
			fill='#EA5E5E'
		/>
		<path
			d='M32.5714 13.7143H46.2857C47.2457 13.7143 47.9999 14.4686 47.9999 15.4286C47.9999 16.3886 47.2457 17.1429 46.2857 17.1429H32.5714C31.6114 17.1429 30.8571 16.3886 30.8571 15.4286C30.8571 14.4686 31.6114 13.7143 32.5714 13.7143Z'
			fill='#BF85BF'
		/>
		<path
			d='M1.71431 13.7143H25.7143C26.6743 13.7143 27.4286 14.4686 27.4286 15.4286C27.4286 16.3886 26.6743 17.1429 25.7143 17.1429H1.71431C0.754309 17.1429 2.28882e-05 16.3886 2.28882e-05 15.4286C2.28882e-05 14.4686 0.754309 13.7143 1.71431 13.7143Z'
			fill='#56B3B4'
		/>
		<path
			d='M12 48H42.8573C43.8173 48 44.5715 48.7543 44.5715 49.7143C44.5715 50.6743 43.8173 51.4286 42.8573 51.4286H12C11.04 51.4286 10.2857 50.6743 10.2857 49.7143C10.2857 48.7543 11.04 48 12 48Z'
			fill='#F7BA3E'
		/>
		<path
			d='M1.71431 48H5.14288C6.10288 48 6.85717 48.7543 6.85717 49.7143C6.85717 50.6743 6.10288 51.4286 5.14288 51.4286H1.71431C0.754309 51.4286 2.28882e-05 50.6743 2.28882e-05 49.7143C2.28882e-05 48.7543 0.754309 48 1.71431 48Z'
			fill='#BF85BF'
		/>
		<path
			d='M42.8573 20.5715H60C60.96 20.5715 61.7143 21.3258 61.7143 22.2857C61.7143 23.2457 60.96 24 60 24H42.8573C41.8973 24 41.143 23.2457 41.143 22.2857C41.143 21.3258 41.8973 20.5715 42.8573 20.5715Z'
			fill='#EA5E5E'
		/>
		<path
			d='M42.8573 27.4286H60C60.96 27.4286 61.7143 28.1829 61.7143 29.1429C61.7143 30.1029 60.96 30.8572 60 30.8572H42.8573C41.8973 30.8572 41.143 30.1029 41.143 29.1429C41.143 28.1829 41.8973 27.4286 42.8573 27.4286Z'
			fill='#F7BA3E'
		/>
		<path
			d='M1.71429 0H42.8571C43.8171 0 44.5714 0.754286 44.5714 1.71429C44.5714 2.67429 43.8171 3.42857 42.8571 3.42857H1.71429C0.754286 3.42857 0 2.67429 0 1.71429C0 0.754286 0.754286 0 1.71429 0Z'
			fill='#56B3B4'
		/>
		<path
			opacity='0.5'
			d='M49.7143 -3.8147e-05H70.2857C71.2457 -3.8147e-05 72 0.754248 72 1.71425C72 2.67425 71.2457 3.42853 70.2857 3.42853H49.7143C48.7543 3.42853 48 2.67425 48 1.71425C48 0.754248 48.7543 -3.8147e-05 49.7143 -3.8147e-05Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M49.7143 48H56.5714C57.5314 48 58.2857 48.7543 58.2857 49.7143C58.2857 50.6743 57.5314 51.4286 56.5714 51.4286H49.7143C48.7543 51.4286 48 50.6743 48 49.7143C48 48.7543 48.7543 48 49.7143 48Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M63.4286 48H70.2858C71.2458 48 72.0001 48.7543 72.0001 49.7143C72.0001 50.6743 71.2458 51.4286 70.2858 51.4286H63.4286C62.4686 51.4286 61.7143 50.6743 61.7143 49.7143C61.7143 48.7543 62.4686 48 63.4286 48Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M60 41.143H70.2858C71.2458 41.143 72.0001 41.8972 72.0001 42.8571C72.0001 43.8171 71.2458 44.5713 70.2858 44.5713H60C59.04 44.5713 58.2857 43.8171 58.2857 42.8571C58.2857 41.8972 59.04 41.143 60 41.143Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M60 6.85712H70.2858C71.2458 6.85712 72.0001 7.61142 72.0001 8.57142C72.0001 9.53143 71.2458 10.2857 70.2858 10.2857H60C59.04 10.2857 58.2857 9.53143 58.2857 8.57142C58.2857 7.61142 59.04 6.85712 60 6.85712Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M63.4286 34.2857H70.2858C71.2458 34.2857 72.0001 35.04 72.0001 35.9999C72.0001 36.9599 71.2458 37.7142 70.2858 37.7142H63.4286C62.4686 37.7142 61.7143 36.9599 61.7143 35.9999C61.7143 35.04 62.4686 34.2857 63.4286 34.2857Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M63.4286 13.7143H70.2858C71.2458 13.7143 72.0001 14.4686 72.0001 15.4286C72.0001 16.3886 71.2458 17.1429 70.2858 17.1429H63.4286C62.4686 17.1429 61.7143 16.3886 61.7143 15.4286C61.7143 14.4686 62.4686 13.7143 63.4286 13.7143Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M66.8572 20.5715H70.2857C71.2457 20.5715 72 21.3258 72 22.2857C72 23.2457 71.2457 24 70.2857 24H66.8572C65.8971 24 65.1429 23.2457 65.1429 22.2857C65.1429 21.3258 65.8971 20.5715 66.8572 20.5715Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M66.8572 27.4286H70.2857C71.2457 27.4286 72 28.1829 72 29.1429C72 30.1029 71.2457 30.8572 70.2857 30.8572H66.8572C65.8971 30.8572 65.1429 30.1029 65.1429 29.1429C65.1429 28.1829 65.8971 27.4286 66.8572 27.4286Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M39.4287 54.8571H70.2857C71.2457 54.8571 72 55.6114 72 56.5714C72 57.5314 71.2457 58.2857 70.2857 58.2857H39.4287C38.4687 58.2857 37.7144 57.5314 37.7144 56.5714C37.7144 55.6114 38.4687 54.8571 39.4287 54.8571Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M25.7143 54.8571H32.5714C33.5314 54.8571 34.2857 55.6114 34.2857 56.5714C34.2857 57.5314 33.5314 58.2857 32.5714 58.2857H25.7143C24.7543 58.2857 24 57.5314 24 56.5714C24 55.6114 24.7543 54.8571 25.7143 54.8571Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M53.1429 68.5714H70.2858C71.2458 68.5714 72.0001 69.3257 72.0001 70.2857C72.0001 71.2457 71.2458 72 70.2858 72H53.1429C52.1829 72 51.4286 71.2457 51.4286 70.2857C51.4286 69.3257 52.1829 68.5714 53.1429 68.5714Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M25.7143 68.5714H46.2857C47.2457 68.5714 47.9999 69.3257 47.9999 70.2857C47.9999 71.2457 47.2457 72 46.2857 72H25.7143C24.7543 72 24 71.2457 24 70.2857C24 69.3257 24.7543 68.5714 25.7143 68.5714Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M25.7143 20.5715H36.0001C36.9601 20.5715 37.7144 21.3258 37.7144 22.2857C37.7144 23.2457 36.9601 24 36.0001 24H25.7143C24.7543 24 24 23.2457 24 22.2857C24 21.3258 24.7543 20.5715 25.7143 20.5715Z'
			fill='#D0D4D8'
		/>
		<path
			opacity='0.5'
			d='M25.7143 27.4286H36.0001C36.9601 27.4286 37.7144 28.1829 37.7144 29.1429C37.7144 30.1029 36.9601 30.8572 36.0001 30.8572H25.7143C24.7543 30.8572 24 30.1029 24 29.1429C24 28.1829 24.7543 27.4286 25.7143 27.4286Z'
			fill='#D0D4D8'
		/>
	</svg>
);

export default PrettierLogo;
